import { db, SETTLEMENT_DATABASE_CACHE_VERSION } from "@/utils/dexie";

const DATABASE_CACHE_VERSION_KEY = "st-admin:database-cache-version";
const LEGACY_BUILD_VERSION_KEY = "st-admin:cache-build-version";

/**
 * Clear every settlement cache table once when the data-cache contract changes.
 *
 * UI-only deployments keep SETTLEMENT_DATABASE_CACHE_VERSION unchanged and
 * preserve IndexedDB. Any release that changes settlement/cache behavior must
 * bump that version so the next app start rebuilds all cached data.
 */
export async function resetSettlementCacheForVersion(): Promise<boolean> {
  if (typeof window === "undefined") return false;

  const expectedVersion = String(SETTLEMENT_DATABASE_CACHE_VERSION);
  let currentVersion: string | null = null;

  try {
    currentVersion = window.localStorage.getItem(DATABASE_CACHE_VERSION_KEY);
  } catch (error) {
    console.warn(
      "Settlement database cache version could not be read; cache will be reset.",
      error
    );
  }

  if (currentVersion === expectedVersion) return false;

  await db.transaction(
    "rw",
    db.results,
    db.orders,
    db.refunds,
    db.orderRefs,
    async () => {
      await db.results.clear();
      await db.orders.clear();
      await db.refunds.clear();
      await db.orderRefs.clear();
    }
  );

  try {
    window.localStorage.setItem(DATABASE_CACHE_VERSION_KEY, expectedVersion);
    window.localStorage.removeItem(LEGACY_BUILD_VERSION_KEY);
  } catch (error) {
    console.warn(
      "Settlement database cache was reset, but its version marker could not be saved.",
      error
    );
  }

  return true;
}
